export default class SmsLimitReachedError extends Error {
    constructor() {
        super();
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
